'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _immutable = require('immutable');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  switch (action.type) {

    case 'GET_SCORES':
      {
        return action.payload.reduce(function (state, data) {
          return state.setIn(['one', data.score.id], (0, _immutable.fromJS)(data.score));
        }, state);
      }

    case 'GET_EVENT_SCORES':
      {
        action.payload.forEach(function (data) {
          data.scores.forEach(function (score) {
            state = state.setIn(['one', score.id], (0, _immutable.fromJS)(score));
          });
        });
        return state;
      }

    case 'GET_SCORES_ERROR':
      return state.setIn(['persons', action.person_id], (0, _immutable.fromJS)({ error: true }));

    case 'GET_SCORESHEET':
      {
        action.payload.forEach(function (data) {
          data.scores.forEach(function (score) {
            state = state.setIn(['one', score.id], (0, _immutable.fromJS)(score));
          });
        });
        return state;
      }

    case 'DELETE_EVENT_SCORES_BY_ADJUDICATOR':
      return action.payload.reduce(function (state, data) {
        return data.scores.reduce(function (state, score) {
          return state.deleteIn(['one', score.id]);
        }, state);
      }, state);

    case 'CREATE_SCORE':
    case 'UPDATE_SCORE':
      return state.setIn(['one', action.payload.id], (0, _immutable.fromJS)(action.payload));

    case 'DELETE_SCORE':
      return state.deleteIn(['one', action.score_id]);

    case 'GET_ALL_EVENT_SCORES':
      {
        var scores = [];
        action.payload.forEach(function (adj) {
          adj.scores.forEach(function (personScores) {
            personScores.scores.forEach(function (round_score) {
              scores.push(_extends({}, round_score, {
                adjudicator: adj.id
              }));
            });
          });
        });
        scores.forEach(function (score) {
          return state = state.setIn(['one', score.id], (0, _immutable.fromJS)(score));
        });
        return state;
      }

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/scores/index.js
// module id = 708
// module chunks = 0